'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ChevronIcon = require('@narvar/nth-bit-icon-chevron');
var Typography = require('../../../../../../common/components/Typography.js');
var StylelessButton = require('../../../../../../common/components/StylelessButotn/StylelessButton.js');
var Disclosure_module = require('./Disclosure.module.css.js');
var Box = require('../../../../../../common/components/layout/Box/Box.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var ChevronIcon__default = /*#__PURE__*/_interopDefaultLegacy(ChevronIcon);

const Disclosure = _ref => {
  let {
    title,
    id,
    showContentText,
    hideContentText,
    children
  } = _ref;
  const [showItems, setShowItems] = React.useState(false);
  return /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Box["default"], null, /*#__PURE__*/React__default["default"].createElement(StylelessButton.StylelessButton, {
    onClick: () => setShowItems(!showItems),
    "aria-expanded": showItems,
    "aria-controls": `${id}-content`,
    "aria-label": (showItems ? hideContentText : showContentText) ?? ''
  }, /*#__PURE__*/React__default["default"].createElement(Typography.PanelHeader, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: Disclosure_module["default"].header
  }, title, /*#__PURE__*/React__default["default"].createElement(ChevronIcon__default["default"], {
    direction: showItems ? ChevronIcon.Direction.Up : ChevronIcon.Direction.Down,
    s: {
      width: '0.75rem',
      verticalAlign: undefined,
      transformOrigin: 'center center',
      paddingBottom: '0.25rem'
    }
  }))))), /*#__PURE__*/React__default["default"].createElement("div", {
    id: `${id}-content`,
    hidden: !showItems,
    className: Disclosure_module["default"].body,
    style: {
      containerType: 'inline-size'
    }
  }, children));
};

exports["default"] = Disclosure;
